import { useNavigate } from "react-router-dom";
import { LuCheck } from "react-icons/lu";
import { Button } from "antd";
import { useTranslation } from "../../../../utils/onboardingI18n";

const ApplicationStatus = ({ status }) => {
  const { t } = useTranslation("onBoarding");
  const navigate = useNavigate();
  const isApproved = String(status || "").toLowerCase() === "approved";

  return (
    <div className="flex flex-col justify-center items-center min-h-[400px] px-4 text-center">
      <div className="flex items-center justify-center p-4 mb-6 border-4 border-green-500 rounded-full">
        <LuCheck size={50} className="text-green-500" />
      </div>

      {isApproved ? (
        <>
          <h1 className="text-3xl font-semibold text-primary mb-3">
            {t("Corporate Onboarding Verified")}
          </h1>

          <p className="text-lg font-medium mb-3 max-w-xl">
            {t("Your corporate onboarding has been successfully verified.")}
          </p>

          <p className="text-gray-500 mb-6 max-w-xl">
            {t("Your live trading account application is approved. You may continue to your dashboard.")}
          </p>
        </>
      ) : (
        <>
          <h1 className="text-3xl font-semibold text-primary mb-3">
            {t("Thank You For Submitting")}
          </h1>

          <p className="text-lg font-medium mb-3">
            {t("Your Live Trading Account Application")}
          </p>

          <p className="text-gray-500 mb-6 max-w-xl">
            {t("We will carefully review your application and notify you once your account is approved.")}
          </p>
        </>
      )}

      <Button
        type="primary"
        size="large"
        onClick={() => navigate("/dashboard")}
      >
        {t("Go to Dashboard")}
      </Button>
    </div>
  );
};

export default ApplicationStatus;
